import type { ChartRenderProps } from '../../lib/charts';
import { formatScaledCount } from '../../lib/scaling';

export default function KpiCard({ blob, indices }: ChartRenderProps) {
  const total = blob.data.length;
  const pct = total > 0 ? (indices.length / total) * 100 : 0;
  return (
    <div className="chart-kpi">
      <div className="chart-kpi__value">{formatScaledCount(indices.length, total)}</div>
      <div className="chart-kpi__sub">
        people · {pct.toFixed(1)}% of {formatScaledCount(total, total)}
      </div>
    </div>
  );
}
